import React from "react";
import PaymentDialogue from "./PaymentDialogue";

function Payment(props) {
  return (
    <>
      <PaymentDialogue />
    </>
  );
}

export default Payment;
